(function (Drupal, once) {
  'use strict';

  Drupal.behaviors.externalLinks = {
    attach: function (context) {
      const links = once('external-links', 'a[href^="http"]', context);
      const currentHost = window.location.hostname;

      links.forEach(link => {
        try {
          const url = new URL(link.href);
          if (url.hostname !== currentHost) {
            if (!link.hasAttribute('target')) {
              link.setAttribute('target', '_blank');
            }
            if (!link.hasAttribute('rel')) {
              link.setAttribute('rel', 'noopener noreferrer');
            } else {
              const rel = link.getAttribute('rel');
              if (!rel.includes('noopener')) link.setAttribute('rel', rel + ' noopener');
              if (!rel.includes('noreferrer')) link.setAttribute('rel', link.getAttribute('rel') + ' noreferrer');
            }
          }
        } catch (e) {}
      });
    }
  };
})(Drupal, once);
